import { SERVICE_MODALS_ERROR_STATES } from "../../ServiceFunctionsModal.types";
import { GeneralErrorsModalType } from "../ServiceModal.types";
import { ResourceSuspended } from "./ResourceSuspended";
import { GeneralError } from "./GeneralError";
import { PostNotFound } from "./PostNotFound";
import { UserInvalid } from "./UserInvalid";
import { NoInternetError } from "./NoInternetError";
import { LimitExceededMessage } from "./LimitExceededMessage";

export function GeneralErrorsModalState({
    modalCurrentAction,
}: GeneralErrorsModalType) {
    switch (modalCurrentAction) {
        case SERVICE_MODALS_ERROR_STATES.RESOURCE_SUSPENDED: {
            return ResourceSuspended();
        }
        case SERVICE_MODALS_ERROR_STATES.RESOURCE_NOT_FOUND: {
            return PostNotFound();
        }
        case SERVICE_MODALS_ERROR_STATES.USER_INACTIVE_OR_SUSPENDED: {
            return UserInvalid();
        }
        case SERVICE_MODALS_ERROR_STATES.LIMIT_EXCEEDED_ERROR: {
            return LimitExceededMessage();
        }
        case SERVICE_MODALS_ERROR_STATES.GENERAL_ERROR: {
            return GeneralError();
        }
        case SERVICE_MODALS_ERROR_STATES.NO_INTERNET: {
            return NoInternetError();
        }
        case SERVICE_MODALS_ERROR_STATES.DEFAULT: {
            return <></>;
        }
    }
}
